"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.VideoBoardRequestIdentifier = exports.VideoBoardNetworkManager = exports.D_UPDATE_VIDEOBOARD = exports.D_GET_BY_ID_VIDEOBOARD = exports.D_GET_ALL_VIDEOBOARDS = exports.D_DELETE_VIDEOBOARD = exports.D_CREATE_VIDEOBOARD = void 0;
var _NetworkManager2 = require("./NetworkManager");
var _enums = require("./enums");
var DEF = _interopRequireWildcard(require("../../defaults"));
var _v = require("../../models/v3");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VideoBoardRequestIdentifier;
exports.VideoBoardRequestIdentifier = VideoBoardRequestIdentifier;
(function (VideoBoardRequestIdentifier) {
  VideoBoardRequestIdentifier["GET_ALL"] = "videoboard list";
  VideoBoardRequestIdentifier["GET"] = "videoboard by id";
  VideoBoardRequestIdentifier["CREATE"] = "create videoboard";
  VideoBoardRequestIdentifier["UPDATE"] = "update videoboard";
  VideoBoardRequestIdentifier["DELETE"] = "delete videoboard";
})(VideoBoardRequestIdentifier || (exports.VideoBoardRequestIdentifier = VideoBoardRequestIdentifier = {}));
var VideoBoardNetworkManager = /*#__PURE__*/function (_NetworkManager) {
  _inherits(VideoBoardNetworkManager, _NetworkManager);
  var _super = _createSuper(VideoBoardNetworkManager);
  function VideoBoardNetworkManager(requestUrl) {
    var _this;
    _classCallCheck(this, VideoBoardNetworkManager);
    _this = _super.call(this, requestUrl);
    _defineProperty(_assertThisInitialized(_this), "getAll", function (lastResponse) {
      var getAll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : D_GET_ALL_VIDEOBOARDS;
      var headOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var paramsArray = _this.paramsObjectToArray(getAll);
      var fullRequestUrl = _this.requestUrl;
      fullRequestUrl = _this.appendUrlParameters(fullRequestUrl, paramsArray);
      return _this.getData(fullRequestUrl, {
        method: headOnly ? _enums.EHttpRequestMethod.HEAD : _enums.EHttpRequestMethod.GET
      }, lastResponse, true);
    });
    _defineProperty(_assertThisInitialized(_this), "getById", function (lastResponse) {
      var getById = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : D_GET_BY_ID_VIDEOBOARD;
      var headOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var paramsArray = _this.paramsObjectToArray(getById);
      var fullRequestUrl = "".concat(_this.requestUrl, "/").concat(getById.id);
      fullRequestUrl = _this.appendUrlParameters(fullRequestUrl, paramsArray);
      return _this.getData(fullRequestUrl, {
        method: headOnly ? _enums.EHttpRequestMethod.HEAD : _enums.EHttpRequestMethod.GET
      }, lastResponse, true);
    });
    _defineProperty(_assertThisInitialized(_this), "create", function () {
      var createVideoBoard = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : D_CREATE_VIDEOBOARD;
      return _this.processedFetch(_this.requestUrl, {
        method: _enums.EHttpRequestMethod.POST,
        body: JSON.stringify(createVideoBoard.videoboard),
        headers: {
          "Content-Type": "application/json"
        }
      }, true);
    });
    _defineProperty(_assertThisInitialized(_this), "update", function () {
      var updateVideoBoard = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : D_UPDATE_VIDEOBOARD;
      var fullRequestUrl = _this.requestUrl + "/".concat(updateVideoBoard.id);
      return _this.processedFetch(fullRequestUrl, {
        method: _enums.EHttpRequestMethod.PUT,
        body: JSON.stringify(updateVideoBoard.videoboard),
        headers: {
          "Content-Type": "application/json"
        }
      }, true);
    });
    _defineProperty(_assertThisInitialized(_this), "delete", function () {
      var deleteVideoBoard = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : D_DELETE_VIDEOBOARD;
      var fullRequestUrl = _this.requestUrl + "/".concat(deleteVideoBoard.id);
      return _this.processedFetch(fullRequestUrl, {
        method: _enums.EHttpRequestMethod.DELETE
      }, true);
    });
    return _this;
  }

  // the ProcessedRequest data should contain a list of objects
  return _createClass(VideoBoardNetworkManager);
}(_NetworkManager2.NetworkManager);
exports.VideoBoardNetworkManager = VideoBoardNetworkManager;
var _default = VideoBoardNetworkManager; // Interfaces & Default Request Objects used by consumers to make api calls 
// utilizing object decomposition to assume defaults and overwrite when desired
/*************************************
    GET ALL
 ************************************/
exports.default = _default;
var D_GET_ALL_VIDEOBOARDS = {
  query: "",
  lightweight: false
};

/*************************************
    GET BY ID
 ************************************/
exports.D_GET_ALL_VIDEOBOARDS = D_GET_ALL_VIDEOBOARDS;
var D_GET_BY_ID_VIDEOBOARD = {
  id: DEF.UNKNOWN_OBJECT_ID
};

/*************************************
    CREATE
 ************************************/
exports.D_GET_BY_ID_VIDEOBOARD = D_GET_BY_ID_VIDEOBOARD;
var D_CREATE_VIDEOBOARD = {
  videoboard: new _v.ATVideoBoard()
};

/*************************************
    UPDATE
 ************************************/
exports.D_CREATE_VIDEOBOARD = D_CREATE_VIDEOBOARD;
var D_UPDATE_VIDEOBOARD = {
  id: DEF.UNKNOWN_OBJECT_ID,
  videoboard: new _v.ATVideoBoard()
};

/*************************************
    DELETE
 ************************************/
exports.D_UPDATE_VIDEOBOARD = D_UPDATE_VIDEOBOARD;
var D_DELETE_VIDEOBOARD = {
  id: DEF.UNKNOWN_OBJECT_ID
};
exports.D_DELETE_VIDEOBOARD = D_DELETE_VIDEOBOARD;